/**
 * Input — DS Atom
 * États : default / focus / error / disabled
 */

import styles from './Input.module.css';

interface InputProps {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  hint?: string;
  disabled?: boolean;
  type?: 'text' | 'email' | 'password' | 'number' | 'search';
  id?: string;
  className?: string;
}

export function Input({
  label,
  placeholder,
  value,
  onChange,
  error,
  hint,
  disabled = false,
  type = 'text',
  id,
  className = '',
}: InputProps) {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      {label && <label className={styles.label} htmlFor={id}>{label}</label>}
      <input
        id={id}
        type={type}
        className={`${styles.input} ${error ? styles.inputError : ''}`}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange?.(e.target.value)}
        disabled={disabled}
      />
      {error && <span className={styles.error}>{error}</span>}
      {hint && !error && <span className={styles.hint}>{hint}</span>}
    </div>
  );
}
